"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const usePrismicPreviewStore = require("../usePrismicPreviewStore.cjs");
const getRepositoryConfig = (repositoryName) => {
  const state = usePrismicPreviewStore.usePrismicPreviewStore.getState();
  return state.repositoryConfigs.find((config) => config.repositoryName === repositoryName);
};
exports.getRepositoryConfig = getRepositoryConfig;
//# sourceMappingURL=getRepositoryConfig.cjs.map
